export class EmailHistoryInput{
    crmUserId:number;
    emailItemId:number;
    sessionToken:string;
}